export let content = {
  English: {
    heading:"Our Gallery",
  },  
  Indonesia:{
    heading:"Galeri Kami",
  }
};
